import React, { useState } from 'react';
import styled from 'styled-components';

import Smile from 'components/Icons/Smile';
import colors from 'utils/colors';
import device from 'utils/device';

export type ComponentProps = {
  title: string;
  subtitle: string;
  link: string;
  onClick?: () => void;
};

const Anchor = styled.a`
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;

  @media ${device.isTablet} {
    justify-content: flex-start;
  }
`;

const IconHolder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 45px;
  height: 45px;
  margin-right: 25px;

  @media ${device.isTablet} {
    padding-bottom: 2px;
  }
`;

const IconHolderInner = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 9px;
  padding-top: 10px;
  border: 2px solid white;
  border-radius: 100px;
  transition: border-color 0.1s ease-in-out;
  padding-left: 10px;

  > svg:hover {
    color: ${colors.orange};
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  margin-top: 0px;

  @media ${device.isTablet} {
    margin-bottom: 5px;
  }
`;

const BaseText = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const Text = styled(BaseText)`
  font-weight: 500;
  line-height: 1.125rem;
  color: ${colors.white};

  @media ${device.isTablet} {
    font-weight: 600;
  }
`;

const Note = styled(BaseText)`
  padding-top: 5px;
  line-height: 1.2;
  color: ${colors.white};

  @media ${device.isTablet} {
    padding-top: 3px;
  }
`;

const Feedback: React.FC<ComponentProps> = ({ title, subtitle, link, onClick = () => {} }) => {
  const [color, setColor] = useState(() => colors.white);

  const onMouseEnterCallback = () => setColor(colors.orange);
  const onMouseLeaveCallback = () => setColor(colors.white);
  return (
    <Anchor
      href={link}
      onClick={onClick}
      onMouseEnter={onMouseEnterCallback}
      onMouseLeave={onMouseLeaveCallback}>
      <IconHolder>
        <IconHolderInner style={{ color, borderColor: color }}>
          <Smile fill={color} />
        </IconHolderInner>
      </IconHolder>
      <TextWrapper>
        <Text style={{ color, borderColor: color }}>{title}</Text>
        <Note style={{ color, borderColor: color }}>{subtitle}</Note>
      </TextWrapper>
    </Anchor>
  );
};

export default Feedback;
